module.exports = __webpack_public_path__ + "static/img/dawan_rdzx2.545121a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dawan/dawan_rdzx2.png
// module id = 707
// module chunks = 0